export const FAKE_RESTAURANTS = [
  {
    id: 'giulia',
    name: "Giulia's Trattoria",
    cuisine: 'Italian',
    price: '$$',
    distance: '0.4 mi',
    rating: 4.8,
    open: true,
    hero: 'linear-gradient(135deg,#FFB88C 0%,#DE6262 100%)',
    photo: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&q=80',
    lng: -74.0026,
    lat: 40.7308,
    safe: [
      { label: 'Vegan options', tone: 1 },
      { label: 'GF pasta', tone: 4 },
      { label: 'Halal meats', tone: 7 },
    ],
    warn: [
      { label: 'Contains nuts', tone: 2 },
      { label: 'Dairy-heavy', tone: 7 },
    ],
    blurb: 'Handmade pasta, wood-fired pizza, a rotating seasonal menu. Chef Giulia trained in Bologna.',
  },
  {
    id: 'sage',
    name: 'Sage & Stem',
    cuisine: 'Plant-based',
    price: '$$',
    distance: '0.9 mi',
    rating: 4.9,
    open: true,
    hero: 'linear-gradient(135deg,#A8E6CF 0%,#3AA17E 100%)',
    photo: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=800&q=80',
    lng: -73.9847,
    lat: 40.7218,
    safe: [
      { label: '100% Vegan', tone: 1 },
      { label: 'GF by default', tone: 4 },
      { label: 'Nut-free kitchen', tone: 0 },
    ],
    warn: [{ label: 'Soy used', tone: 7 }],
    blurb: 'Bright, herby, seasonal vegetables. A dedicated allergen-free kitchen.',
  },
  {
    id: 'baba',
    name: "Baba's Mezze",
    cuisine: 'Levantine',
    price: '$$',
    distance: '1.2 mi',
    rating: 4.7,
    open: false,
    hero: 'linear-gradient(135deg,#F4A261 0%,#E76F51 100%)',
    photo: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=800&q=80',
    lng: -73.9580,
    lat: 40.7194,
    safe: [
      { label: 'Halal', tone: 7 },
      { label: 'Many vegetarian', tone: 0 },
      { label: 'GF options', tone: 4 },
    ],
    warn: [{ label: 'Contains sesame', tone: 2 }],
    blurb: 'Wood-fired flatbread, charcoal lamb, mezze platters. Family-run since 2003.',
  },
  {
    id: 'koji',
    name: 'Koji Ramen Bar',
    cuisine: 'Japanese',
    price: '$',
    distance: '0.6 mi',
    rating: 4.6,
    open: true,
    hero: 'linear-gradient(135deg,#F9C5D1 0%,#FC9A9A 100%)',
    photo: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=800&q=80',
    lng: -73.9912,
    lat: 40.7260,
    safe: [
      { label: 'Vegan broth avail.', tone: 1 },
      { label: 'GF rice noodles', tone: 4 },
    ],
    warn: [
      { label: 'Contains soy', tone: 7 },
      { label: 'Contains gluten', tone: 2 },
    ],
    blurb: 'Tonkotsu, shoyu, and a daily vegan broth made from kombu and roasted mushroom.',
  },
];

export const FAKE_MENU = [
  {
    section: 'Antipasti',
    items: [
      {
        name: 'Focaccia al Rosmarino',
        desc: 'House focaccia, olive oil, sea salt, rosemary.',
        price: '$8',
        tags: [
          { label: 'Vegetarian', tone: 0 },
          { label: 'Contains gluten', tone: 2 },
        ],
      },
      {
        name: 'Caprese di Bufala',
        desc: 'Buffalo mozzarella, heirloom tomato, torn basil.',
        price: '$14',
        tags: [
          { label: 'Vegetarian', tone: 0 },
          { label: 'GF', tone: 4 },
          { label: 'Dairy', tone: 7 },
        ],
      },
    ],
  },
  {
    section: 'Primi',
    items: [
      {
        name: 'Tagliatelle al Ragù',
        desc: '6-hour beef ragù, hand-cut tagliatelle, Parmigiano.',
        price: '$22',
        tags: [
          { label: 'Contains gluten', tone: 2 },
          { label: 'Contains dairy', tone: 7 },
        ],
      },
      {
        name: 'Cacio e Pepe GF',
        desc: 'Pecorino Romano, cracked black pepper, gluten-free spaghetti.',
        price: '$19',
        tags: [
          { label: 'Gluten-Free', tone: 4 },
          { label: 'Vegetarian', tone: 0 },
        ],
      },
    ],
  },
  {
    section: 'Dolci',
    items: [
      {
        name: 'Torta alla Nocciola',
        desc: 'Hazelnut cake, mascarpone cream.',
        price: '$11',
        tags: [
          { label: 'Contains nuts', tone: 2 },
          { label: 'Contains dairy', tone: 7 },
        ],
      },
    ],
  },
];
